import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import {
  CompositeWidgetDefinition,
  CompositeWidgetEntry,
  WidgetEntry,
} from '@/models/Charts/compositeWidgetDefinition';
import IconSwitch from '@/components/switch/IconSwitch.vue';
import SingleWidgetContainer from '@/components/Charts/widgetContainer/SingleWidgetContainer.vue';
import { computed, inject, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';


/** @deprecated THIS COMPONENT IS FROZEN
 * Component to show a widget with mode switch if a composite widget is provided
 *  instead of a widget definition.
 *
 * Two properties (coming from Chart) are available to the default slot:
 *
 * - data: Contains the data retrieved by the DataRetriever defined for the
 *   widget. Beware that it will be null until the data is retrieved. This is
 *   to allow the slot to handle the "no data" case (tables, for example).
 * - loading: true while the data is being retrieved.
 *
 * Usage:
 * <widget-container
 *   :widgetDefinition="widgetDefinition"
 *   v-slot="{ data, loading }"
 * >
 *     <div v-if="!isEmpty(data)" class="default-slot">
 *       {{ data.foo }}
 *     </div>
 * </widget-container>
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WidgetContainer',
  props: {
    widgetDefinition: null,
    selfManagedFilters: { type: Boolean, default: false },
    threeDotsInnerPosition: { default: 'is-right' },
    widgetHelpPosition: { default: 'is-bottom-right' },
    autorefresh: { type: Boolean, default: true },
    isWidgetSelector: { type: Boolean, default: false },
    customerNo: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ((e: 'change', value: CompositeWidgetDefinition | WidgetDefinition) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { widgetDefinition: WidgetEntry, selfManagedFilters: boolean, threeDotsInnerPosition: string, widgetHelpPosition: string, autorefresh: boolean, isWidgetSelector: boolean, customerNo?: string };





const $grid = inject<InstanceType<typeof LayoutGrid> | undefined>(
  '$grid',
  undefined,
);
const showFirstWidget = ref(true);

onBeforeMount(() => {
  $grid?.refreshWidgets();
});

function onWidgetDefinitionChanged(widgetDefinition: WidgetDefinition) {
  if (hasManyDefinitions()) {
    const wd = props.widgetDefinition as CompositeWidgetDefinition;
    const leftWasUpdated =
      wd.left.widgetDefinition.widget === widgetDefinition.widget;
    const updatedCompositeWidgetDefinition = wd.clone();
    if (leftWasUpdated) {
      updatedCompositeWidgetDefinition.left.widgetDefinition = widgetDefinition;
    } else {
      updatedCompositeWidgetDefinition.right.widgetDefinition =
        widgetDefinition;
    }
    emit('change', updatedCompositeWidgetDefinition);
  } else {
    emit('change', widgetDefinition);
  }
}

function onSwitchImage(isRightOptionSelected: boolean) {
  // Value will be true when switch is to the right
  showFirstWidget.value = !isRightOptionSelected;
  resetPreviousWidgetParamValues(isRightOptionSelected);
}

function resetPreviousWidgetParamValues(isRightOptionSelected: boolean) {
  if (isRightOptionSelected) {
    (
      props.widgetDefinition as CompositeWidgetDefinition
    ).left.widgetDefinition.paramValues = {};
  } else {
    (
      props.widgetDefinition as CompositeWidgetDefinition
    ).right.widgetDefinition.paramValues = {};
  }
}

function hasManyDefinitions(): boolean {
  return props.widgetDefinition.isComposite();
}

const widgetEntry = computed((): CompositeWidgetEntry | undefined => {
  if (hasManyDefinitions()) {
    const wd = props.widgetDefinition as CompositeWidgetDefinition;
    return showFirstWidget.value ? wd.left : wd.right;
  } else {
    return undefined;
  }
});

const resolvedWidgetDefinition = computed((): WidgetDefinition => {
  if (hasManyDefinitions()) {
    return widgetEntry.value!.widgetDefinition;
  } else {
    return props.widgetDefinition as WidgetDefinition;
  }
});

const leftIcon = computed((): string => {
  const wd = props.widgetDefinition as CompositeWidgetDefinition;
  return wd.left.icon;
});

const leftIconPack = computed((): string | undefined => {
  const wd = props.widgetDefinition as CompositeWidgetDefinition;
  return wd.left.iconPack;
});

const rightIcon = computed((): string => {
  const wd = props.widgetDefinition as CompositeWidgetDefinition;
  return wd.right.icon;
});

const rightIconPack = computed((): string | undefined => {
  const wd = props.widgetDefinition as CompositeWidgetDefinition;
  return wd.right.iconPack;
});

onBeforeUnmount(() => {
  $grid?.refreshWidgets();
});

return { __sfc: true,props, emit, $grid, showFirstWidget, onWidgetDefinitionChanged, onSwitchImage, resetPreviousWidgetParamValues, hasManyDefinitions, widgetEntry, resolvedWidgetDefinition, leftIcon, leftIconPack, rightIcon, rightIconPack, IconSwitch, SingleWidgetContainer }
}

})